import { render, staticRenderFns } from "./ECommerceProductDetailsRelatedProducts.vue?vue&type=template&id=f84b7300&scoped=true&"
import script from "./ECommerceProductDetailsRelatedProducts.vue?vue&type=script&lang=js&"
export * from "./ECommerceProductDetailsRelatedProducts.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceProductDetailsRelatedProducts.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ECommerceProductDetailsRelatedProducts.vue?vue&type=style&index=1&id=f84b7300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84b7300",
  null
  
)

export default component.exports